import React, { useMemo } from 'react'
import { Typography } from '@material-ui/core'
import styled from '@emotion/styled'
import { useRouter } from '../../../../utils/helper'
import DetailPage from '../../../components/templates/DetailPage'
import UserCard from '../../user/UserProfile/UserCard'
import TransactionCard from '../../transaction/TransactionDetail/TransactionCard'
import dayjs from 'dayjs'
import { Authorize } from '../../../components/Authorize'
import { appConfig } from '../../../constants/app-config'
import { ROLE } from '../../../services/user/user-typed'
import { useGetDcaRecordById } from '../../../services/import-dca/import-dca-query'
import { useTranslation } from 'react-i18next'

const TextLib = styled(Typography)`
  line-height: 2 !important;
`

const Grid = styled.div`
  display: grid;
  grid-gap: 10px;
  margin-top: 10px;
`

const Flex = styled(Grid)`
  display: flex;
  grid-gap: 10px;
  margin-top: 0px;
`
const TextColor = styled(TextLib)<{ color?: string }>`
  color: ${({ color }) => color};
  font-weight: bold !important;
`
const ImportDcaRecordDetail = () => {
  const { id } = useRouter().query

  const { data: dcaRecord } = useGetDcaRecordById(id)
  const { t } = useTranslation()
  const {
    user,
    transactionId,
    transaction,
    isvPaymentRef,
    productRef1,
    status,
    amount,
    createdAt,
    errorMessage,
    type,
  } = dcaRecord || {}
  const portData = useMemo(
    () => [
      {
        label: 'isvPaymentRef',
        value: isvPaymentRef || '-',
      },
      {
        label: 'ref',
        value: productRef1 || '-',
      },
      {
        label: 'Amount',
        value: `${amount}` || '-',
      },
      {
        label: 'type ',
        value: type || '-',
      },
      { label: 'Status', value: status || '-' },
      { label: 'createdAt', value: dayjs(createdAt).format('D MMMM YYYY HH:mm') },
      { label: 'errorMessage', value: errorMessage ? `${errorMessage}-${t(errorMessage)}` : '-' },
    ],
    [amount, createdAt, errorMessage, isvPaymentRef, productRef1, status, t, type],
  )

  const fullName = useMemo(() => {
    return `${user?.firstnameTh} ${user?.lastnameTh}`
  }, [user])

  return appConfig.ENABLE_FEATURE_IMPORT_DCA ? (
    <Authorize role={ROLE.FINANCE}>
      <DetailPage
        title={
          <Flex>
            <TextColor variant="h5">Dca Record</TextColor>
          </Flex>
        }
        contents={portData}
        gridItems={[
          <UserCard userId={dcaRecord?.userId || ''} />,
          transactionId ? (
            <TransactionCard portId={transaction?.portId} fullname={fullName} />
          ) : (
            <></>
          ),
        ]}
      />
    </Authorize>
  ) : (
    <></>
  )
}

export default ImportDcaRecordDetail
